export default __webpack_public_path__ + "static/404-50b20a9762fee83242e3a4277d0eb930.png";